import { gql } from "@apollo/client";

export const UPDATE_TERMINALS_INFO = gql`
  mutation UpdateConfig($domain: String!, $terminalid: Int!, $config: TerminalConfigInput!) {
    terminal {
      updateConfig(domain: $domain, terminalid: $terminalid, config: $config) {
        code
        success
        message
      }
    }
  }
`

export interface UpdateTerminalConfig {
  fk_locations?: number
  deviceId?: number
  fk_terminal_types?: number
  port?: number
  fk_components?: number
  terminal_config_id?: number
  parent?: number
  val1_type: number
  val1_min?: number
  val1_max?: number
  val2_type?: number
  val2_min?: number
  val2_max?: number
  extra?: number
}

interface UpdateTerminal {
  code: String
  success: Boolean
  message: string
}

export interface UpdateTerminalResponse {
  terminal: {
    updateConfig: UpdateTerminal
  }
}